/* unplugin-vue-components disabled */import { render } from "./colorstyle.vue?vue&type=template&id=66e4629d&scoped=true"
import script from "./colorstyle.vue?vue&type=script&lang=js"
export * from "./colorstyle.vue?vue&type=script&lang=js"

import "./colorstyle.vue?vue&type=style&index=0&id=66e4629d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e4629d"]])

export default __exports__